import React from 'react';
import Image from '@/components/shared/Image';
import { splitBanner } from '@/components/ui/Banner/SplitBanner/styles';

interface ISideImageProps {
  image: {
    url: string;
    alt: string;
  };
}
export const SideImage = ({ image }: ISideImageProps) => {
  const { sideImage } = splitBanner();
  return (
    <div className={sideImage()}>
      {image && (
        <Image
          src={image?.url ?? '/'}
          sizes="50vw"
          fill
          alt={image?.alt ?? ''}
          className="object-cover"
        />
      )}
    </div>
  );
};
